import React from 'react';
import { List, CheckCircle2 } from 'lucide-react';
import { useAdminDesign } from './AdminDesignScope';
interface Props extends React.TableHTMLAttributes<HTMLTableElement> { title?: string; }
export default function AdminTable({ title = 'Listado de registros', children, ...props }: Props) {
    const active = useAdminDesign();
    if (!active) return <table {...props}>{children}</table>;
    return <section className="admin-table-frame" data-admin-table-frame="true">
        <div className="admin-table-heading"><span><i><List size={14} /></i>{title}</span><small><CheckCircle2 size={11} />Actualizado</small></div>
        <div className="admin-table-scroll"><table {...props}>{children}</table></div>
    </section>;
}
